<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{ data.sysText.addRole | titlecase }}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button
      type="button"
      class="button-reset"
      mat-dialog-close
      [aria-label]="data.sysText.cancel"
      [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>
<mat-dialog-content>
  <p class="body2">{{ data.sysText.addRoleDesc | capitalizefirst }}</p>
  <app-select-field
    [control]="selectedRole"
    [label]="data.sysText.selectRole"
    [options]="roleOptions"
    [icon]="'verified_user'"
    [shouldCapitalize]="false"
  ></app-select-field>
  <p class="body2 role-desc">{{ roleNotes }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      mat-dialog-close
      color="accent"
      [disabled]="isSubmitting">
      {{ data.sysText.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks.
  it stays focusable when the selection is invalid too (backend errors make it invalid while it has focus), so the guard repeats that check -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting || !selectedRole.valid"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && selectedRole.valid && onSubmit()">
    {{ data.sysText.save }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>

